export function dataInRequest(params = {}) {
  return {
    type: '@checkliberadoparaintegracao/DATA_IN_REQUEST',
    payload: { params },
  };
}

export function findData(id) {
  return {
    type: '@checkliberadoparaintegracao/FIND_DATA',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@checkliberadoparaintegracao/FAILED_REQUEST',
  };
}

export function deleteData(id, params) {
  return {
    type: '@checkliberadoparaintegracao/DELETE_DATA',
    payload: { id, params },
  };
}

export function updateData(data, params) {
  return {
    type: '@checkliberadoparaintegracao/UPDATE_DATA',
    payload: { data, params },
  };
}

export function storeData(data, params) {
  return {
    type: '@checkliberadoparaintegracao/STORE_DATA',
    payload: { data, params },
  };
}

export function successInRequest(data, page, pageSize, totalCount, totalPages) {
  return {
    type: '@checkliberadoparaintegracao/SUCCESS_IN_REQUEST',
    payload: { data, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(data) {
  return {
    type: '@checkliberadoparaintegracao/SUCCESS_REQUEST',
    payload: { data },
  };
}

export function successRemove(params) {
  return {
    type: '@checkliberadoparaintegracao/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@checkliberadoparaintegracao/RECORD_FILTERING',
    payload: { params },
  };
}
